import { render, staticRenderFns } from "./EstCard.vue?vue&type=template&id=2448559e"
import script from "./EstCard.vue?vue&type=script&lang=js"
export * from "./EstCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports